module.exports = __webpack_public_path__ + "media/assets/events/stamp_expo2026-b549b52bc387bc3888b8ccd8c6ac1495.png";